import React, { useState } from 'react';
import {
  Volume2,
  Briefcase,
  ChevronRight,
} from 'lucide-react';
import { Card } from '../ui/card';

const SCENARIOS = {
  programmer: [
    {
      id: 'sc-p1',
      title: 'Tägliches Stand-up-Meeting (Daily Scrum)',
      subtitle: 'Raportimi i progresit të djeshëm, detyrave të sotme dhe bllokuesve teknikë',
      context: 'Çdo mëngjes në orën 09:30, ekipi i zhvillimit mblidhet për 15 minuta për të koordinuar punën.',
      dialogue: [
        {
          speaker: 'Scrum Master (Thomas)',
          role: 'Scrum Master',
          de: 'Guten Morgen allerseits! Fangen wir an. Fatli, wie sieht es bei dir aus?',
          sq: 'Mirëmëngjes të gjithëve! Le të fillojmë. Fatli, si po shkon te ti?',
        },
        {
          speaker: 'Du (Entwickler)',
          role: 'Software Developer',
          de: 'Guten Morgen! Gestern habe ich die REST-Schnittstelle für die Benutzerregistrierung fertiggestellt und Unit-Tests dafür geschrieben.',
          sq: 'Mirëmëngjes! Dje përfundova ndërfaqen REST për regjistrimin e përdoruesve dhe shkrova unit teste për të.',
        },
        {
          speaker: 'Du (Entwickler)',
          role: 'Software Developer',
          de: 'Heute plane ich, den Pull-Request für die Codeüberprüfung einzureichen und mit der Token-Validierung zu beginnen.',
          sq: 'Sot kam në plan të dorëzoj pull request-in për rishikim kodi dhe të filloj me validimin e token-it.',
        },
        {
          speaker: 'Scrum Master (Thomas)',
          role: 'Scrum Master',
          de: 'Gibt es irgendwelche Blocker oder Hindernisse, bei denen du Unterstützung brauchst?',
          sq: 'A ka ndonjë bllokues ose pengesë ku të nevojitet mbështetje?',
        },
        {
          speaker: 'Du (Entwickler)',
          role: 'Software Developer',
          de: 'Ja, die Staging-Datenbank ist seit heute früh nicht erreichbar. Lukas, kannst du dir die Verbindung kurz ansehen?',
          sq: 'Po, baza e të dhënave në Staging nuk po aksesohet që nga mëngjesi. Lukas, a mund t\'i hedhësh një sy shpejt lidhjes?',
        },
        {
          speaker: 'DevOps (Lukas)',
          role: 'DevOps Engineer',
          de: 'Klar, ich starte den Container neu und gebe dir im Slack-Channel Bescheid.',
          sq: 'Sigurisht, po e rinis kontejnerin dhe të lajmëroj në kanalin e Slack-ut.',
        },
      ],
    },
    {
      id: 'sc-p2',
      title: 'Code-Review & Architektur-Diskussion',
      subtitle: 'Diskutim profesional me Tech Lead-in gjerman mbi refaktorimin e një moduli',
      context: 'Po diskuton një pull request të madh ku kërkohet përmirësim i performancës dhe trajtimit të gabimeve.',
      dialogue: [
        {
          speaker: 'Tech Lead (Markus)',
          role: 'Senior Software Architect',
          de: 'Ich habe deinen Pull-Request durchgesehen. Die Architektur ist sehr modular, aber ich habe zwei Anmerkungen.',
          sq: 'E shikova pull request-in tënd. Arkitektura është shumë modulare, por kam dy vërejtje.',
        },
        {
          speaker: 'Du (Entwickler)',
          role: 'Software Developer',
          de: 'Gerne! Um welche Stellen im Code handelt es sich genau?',
          sq: 'Me kënaqësi! Për cilat pjesë në kod bëhet fjalë saktësisht?',
        },
        {
          speaker: 'Tech Lead (Markus)',
          role: 'Senior Software Architect',
          de: 'In Zeile 45 führst du eine verschachtelte Datenbankabfrage innerhalb einer Schleife aus. Das führt zum N+1-Problem.',
          sq: 'Në rreshtin 45 po ekzekuton një query të ndërthurur brenda një cikli. Kjo shkakton problemin N+1.',
        },
        {
          speaker: 'Du (Entwickler)',
          role: 'Software Developer',
          de: 'Stimmt, das ist ineffizient. Ich werde die Datensätze per JOIN in einer einzigen Abfrage zusammenfassen.',
          sq: 'E vërtetë, kjo është jo-efikase. Do t\'i bashkoj të dhënat me JOIN në një kërkesë të vetme.',
        },
        {
          speaker: 'Tech Lead (Markus)',
          role: 'Senior Software Architect',
          de: 'Hervorragend. Wenn du das angepasst hast, gebe ich den Merge sofort frei.',
          sq: 'Shkëlqyeshëm. Sapo ta përshtatësh këtë, unë menjëherë e aprovoj bashkimin (merge).',
        },
      ],
    },
  ],
  mechatronics: [
    {
      id: 'sc-m1',
      title: 'Störungssuche an der Fertigungslinie',
      subtitle: 'Komunikimi teknik gjatë një avarie emergjente në linjën e montimit',
      context: 'Linja 4 është ndalur sepse një cilindër pneumatik nuk po arrin pozicionin përfundimtar.',
      dialogue: [
        {
          speaker: 'Schichtleiter (Klaus)',
          role: 'Udhëheqësi i Turnit',
          de: 'Fatli, Band 4 steht seit fünf Minuten still! Die SPS meldet einen Fehler an Station 3.',
          sq: 'Fatli, linja 4 ka 5 minuta që ka ndaluar! PLC raporton një defekt në Stacionin 3.',
        },
        {
          speaker: 'Du (Mechatroniker)',
          role: 'Inxhinier Mekatronik',
          de: 'Ich bin schon am Schaltschrank. Laut Diagnosepuffer schaltet der Endlagenschalter B2 nicht durch.',
          sq: 'Jam tashmë te kabina elektrike. Sipas buffer-it diagnostikues, çelësi fundor B2 nuk po jep sinjal.',
        },
        {
          speaker: 'Schichtleiter (Klaus)',
          role: 'Udhëheqësi i Turnit',
          de: 'Ist der Sensor defekt oder liegt es an der Druckluftversorgung?',
          sq: 'A është dëmtuar sensori apo bëhet fjalë për furnizimin me ajër të kompresuar?',
        },
        {
          speaker: 'Du (Mechatroniker)',
          role: 'Inxhinier Mekatronik',
          de: 'Der Betriebsdruck liegt stabil bei 6 bar. Aber der induktive Sensor hat sich mechanisch gelockert und keinen Kontakt.',
          sq: 'Presioni i punës është i qëndrueshëm në 6 bar. Por sensori induktiv është liruar mekanikisht dhe nuk ka kontakt.',
        },
        {
          speaker: 'Du (Mechatroniker)',
          role: 'Inxhinier Mekatronik',
          de: 'Ich justiere den Sensor neu und ziehe die Kontermutter fest. In zwei Minuten können wir den Probelauf starten.',
          sq: 'Po e ri-rregulloj sensorin dhe po shtrëngoj dado-siguresën. Pas dy minutash mund të nisim provën.',
        },
        {
          speaker: 'Schichtleiter (Klaus)',
          role: 'Udhëheqësi i Turnit',
          de: 'Sehr gut reagiert! Vergiss bitte nicht, die Störung im Wartungsbuch einzutragen.',
          sq: 'Reagim shumë i mirë! Të lutem mos harro ta regjistrosh avarinë në librin e mirëmbajtjes.',
        },
      ],
    },
    {
      id: 'sc-m2',
      title: 'Schichtübergabe & Wartungsbesprechung',
      subtitle: 'Dorëzimi i turnit të paradites tek kolegu i pasdites në fabrikë',
      context: 'Dorëzimi i rregullt i përgjegjësive midis teknikëve të turnit të parë dhe të dytë.',
      dialogue: [
        {
          speaker: 'Kollege Spätschicht (Stefan)',
          role: 'Kolegu i Turnit të Pasdites',
          de: 'Hallo Fatli! Wie lief die Frühschicht? Gibt es Auffälligkeiten an den Maschinen?',
          sq: 'Përshëndetje Fatli! Si shkoi turni i mëngjesit? A ka ndonjë anomali te makineritë?',
        },
        {
          speaker: 'Du (Mechatroniker)',
          role: 'Inxhinier Mekatronik',
          de: 'Im Großen und Ganzen lief alles nach Plan. Bei Maschine 2 haben wir das Getriebeöl gewechselt.',
          sq: 'Në përgjithësi gjithçka shkoi sipas planit. Te Makina 2 ndërruam vajin e reduktorit/transmisionit.',
        },
        {
          speaker: 'Du (Mechatroniker)',
          role: 'Inxhinier Mekatronik',
          de: 'Allerdings zieht der Hauptschütz K1 etwas träge an. Bitte behalte die Temperatur im Schaltschrank im Auge.',
          sq: 'Megjithatë, kontaktori kryesor K1 po tërhiqet pak me vonesë. Ju lutem mbani nën vëzhgim temperaturën në kabinë.',
        },
        {
          speaker: 'Kollege Spätschicht (Stefan)',
          role: 'Kolegu i Turnit të Pasdites',
          de: 'Alles klar, ich werde bei der nächsten Pause eine Wärmebildmessung durchführen. Danke dir und schönen Feierabend!',
          sq: 'E qartë, në pushimin e ardhshëm do të bëj një matje me kamerë termike. Faleminderit dhe pushim të mbarë!',
        },
      ],
    },
  ],
};

export default function WorkplaceScenarios({ profession }) {
  const isProgrammer = profession === 'programmer';
  const scenarios = SCENARIOS[isProgrammer ? 'programmer' : 'mechatronics'] || [];
  const [activeScenarioId, setActiveScenarioId] = useState(scenarios[0]?.id);

  const activeScenario = scenarios.find((s) => s.id === activeScenarioId) || scenarios[0];

  const speak = (text) => {
    if (!('speechSynthesis' in window)) return;
    window.speechSynthesis.cancel();
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = 'de-DE';
    utterance.rate = 0.9;
    window.speechSynthesis.speak(utterance);
  };

  return (
    <div className="space-y-6">
      {/* Selector pills */}
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {scenarios.map((sc) => (
          <button
            key={sc.id}
            type="button"
            onClick={() => setActiveScenarioId(sc.id)}
            className={`flex flex-col text-left p-4 rounded-2xl border transition-all ${
              activeScenarioId === sc.id
                ? 'border-zinc-500 bg-zinc-950 text-white shadow-md'
                : 'border-zinc-200 bg-white text-zinc-900 hover:border-zinc-400'
            }`}
          >
            <div className="flex items-center justify-between">
              <span
                className={`text-[10px] font-extrabold uppercase tracking-wider rounded-md px-2 py-0.5 ${
                  activeScenarioId === sc.id
                    ? 'bg-[#FFCE00] text-zinc-950'
                    : 'bg-zinc-100 text-zinc-600'
                }`}
              >
                Situatë në Punë
              </span>
              <ChevronRight
                size={16}
                className={activeScenarioId === sc.id ? 'text-[#FFCE00]' : 'text-zinc-400'}
              />
            </div>
            <strong className="mt-2 text-sm font-extrabold block truncate">{sc.title}</strong>
            <p
              className={`mt-1 text-xs line-clamp-1 ${
                activeScenarioId === sc.id ? 'text-zinc-400' : 'text-zinc-500'
              }`}
            >
              {sc.subtitle}
            </p>
          </button>
        ))}
      </div>

      {/* Active Scenario Card */}
      {activeScenario && (
        <Card className="overflow-hidden rounded-2xl bg-white shadow-md">
          {/* Scenario Context Banner */}
          <div className="border-b border-zinc-100 bg-zinc-50/70 p-5">
            <div className="flex items-center gap-2 text-xs font-bold text-zinc-500 uppercase tracking-wider">
              <Briefcase size={14} className="text-[#DD0000]" /> Konteksti i Situatës
            </div>
            <h3 className="mt-1 text-lg font-extrabold text-zinc-950 tracking-tight">
              {activeScenario.title}
            </h3>
            <p className="mt-1 text-xs text-zinc-600 leading-relaxed">{activeScenario.context}</p>
          </div>

          {/* Dialogue Lines */}
          <div className="p-5 space-y-4">
            {activeScenario.dialogue.map((line, idx) => {
              const isUserSpeaker = line.speaker.startsWith('Du');
              return (
                <div
                  key={idx}
                  className={`flex flex-col rounded-2xl p-4 transition-all ${
                    isUserSpeaker
                      ? 'border border-[#FFCE00]/40 bg-[#FFCE00]/10 ml-4 sm:ml-8'
                      : 'border border-zinc-100 bg-zinc-50/70 mr-4 sm:mr-8'
                  }`}
                >
                  <div className="flex items-center justify-between gap-2 mb-1.5">
                    <div className="flex items-center gap-2">
                      <span className="flex h-6 w-6 items-center justify-center rounded-lg bg-zinc-900 text-[10px] font-bold text-[#FFCE00]">
                        {line.speaker[0]}
                      </span>
                      <span className="text-xs font-extrabold text-zinc-900">{line.speaker}</span>
                      <span className="text-[10px] text-zinc-400 font-medium">({line.role})</span>
                    </div>

                    <button
                      type="button"
                      onClick={() => speak(line.de)}
                      className="flex items-center gap-1 rounded-lg bg-white px-2 py-1 text-[11px] font-bold text-zinc-700 shadow-2xs hover:bg-zinc-100 transition"
                      title="Dëgjo fjalinë në gjermanisht"
                    >
                      <Volume2 size={13} className="text-zinc-600" />
                      <span className="hidden sm:inline">Dëgjo</span>
                    </button>
                  </div>

                  {/* German text */}
                  <p className="text-xs font-bold text-zinc-950 leading-relaxed">
                    "{line.de}"
                  </p>

                  {/* Albanian text */}
                  <p className="mt-1 text-[11px] font-medium text-zinc-500 italic">
                    "{line.sq}"
                  </p>
                </div>
              );
            })}
          </div>
        </Card>
      )}
    </div>
  );
}
